import { render, staticRenderFns } from "./WhatsappContactListSwitcher.vue?vue&type=template&id=1cc7ecaf"
import script from "./WhatsappContactListSwitcher.vue?vue&type=script&lang=js"
export * from "./WhatsappContactListSwitcher.vue?vue&type=script&lang=js"
import style0 from "./WhatsappContactListSwitcher.vue?vue&type=style&index=0&id=1cc7ecaf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports